import { Component, OnInit } from '@angular/core';
import { AppComponent } from './app.component';
import { LoginService } from './login/login.service';
import {MenuService} from './app.menu.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(public app: AppComponent, public loginService: LoginService,public menuService : MenuService) { }

    ngOnInit() {
        this.loginService.loginEmetteur.subscribe(async (value: any) => {
            this.model  = await this.menuService.getMainMenu();
        });
        this.loginService.loginEmetteur.emit({});
    }
}
